<main id="otp" class="w-screen flex flex-col justify-center">
  <div class=" max-w-sm mx-auto white-card">
    <div class="header-wr">
      <img class="mx-auto company-logo" src="../../../../../assets/logos/aricoma-dark.svg" [attr.alt]="'LOGIN.LOGO_ALT' | translate" (click)="backToLogin()">
      <h2 class="text-center">{{ 'OTP.OTP_TOO_MANY_REQUESTS_TITLE' | translate }}</h2>
    </div>
    <div class="notice error text-sm mt-8 mb-8">
      <p>{{ 'OTP.OTP_TOO_MANY_REQUESTS_DESCRIPTION' | translate }}</p>
    </div>
    <div class="row mt-2">
      <div class="btn-wr mb-2">
        <button class="btn primary-btn w-full" (click)="backToLogin()">{{ 'NEW_PASSWORD.BACK_TO_LOGIN_LINK' |
          translate }}</button>
      </div>
    </div>
  </div>
</main>

